import { DarkLightSwitch } from "src/components/ui";
import { useDarkMode } from "src/contexts/them-context/ThemContext";

const LightDarkMode = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  return (
    <>
      <DarkLightSwitch checked={!isDarkMode} onChange={toggleDarkMode} />
    </>
  );
};

export default LightDarkMode;
